import { createAction, props } from "@ngrx/store";
import {
    AvailableDynamicSection,
    RegisterEntityType,
    SensorConfigurationCollection,
    SensorMonitoringPointDataSource
} from "../models/dynamic-section-models";
import { FlexCreateMode } from "../reducers";
import { HttpErrorResponse } from "@angular/common/http";

export enum FlexActionType {
    FLEX_CHANGE_SENSOR = '@form/FLEX_CHANGE_SENSOR',
    FLEX_CHANGE_CHANNEL = '@form/FLEX_CHANGE_CHANNEL',
    FLEX_CHANGE_MONITOR_POINT = '@form/FLEX_CHANGE_MONITOR_POINT',
    FLEX_COMM_PORT_CHANGE = '@form/FLEX_COMM_PORT_CHANGE',
    FLEX_SET_SILT_VALUE = '@form/FLEX_SET_SILT_VALUE',
    FLEX_SET_CREATE_MODE = '@form/FLEX_SET_CREATE_MODE',
    FLEX_EVALUATE_SCAN_MODE_LOCK = '@form/FLEX_EVALUATE_SCAN_MODE_LOCK',
    LOAD_SENSOR_COLLECTION = '@form/LOAD_SENSOR_COLLECTION',
    LOAD_SENSOR_COLLECTION_SUCCESS = '@form/LOAD_SENSOR_COLLECTION_SUCCESS',
    LOAD_SENSOR_COLLECTION_FAILURE = '@form/LOAD_SENSOR_COLLECTION_FAILURE',
    SAVE_SENSOR_COLLECTION = '@form/SAVE_SENSOR_COLLECTION',
    SAVE_SENSOR_COLLECTION_SUCCESS = '@form/SAVE_SENSOR_COLLECTION_SUCCESS',
    SAVE_SENSOR_COLLECTION_FAILURE = '@form/SAVE_SENSOR_COLLECTION_FAILURE',
    UPDATE_MP1_PREFERENCES = '@form/UPDATE_MP1_PREFERENCES',
    UPDATE_MP2_PREFERENCES = '@form/UPDATE_MP2_PREFERENCES',
    CLEAR_MP2_PREFERENCES = '@form/CLEAR_MP2_PREFERENCES',
    UPDATE_MP1_DEPTH_ENTITY_TYPE = '@form/UPDATE_MP1_DEPTH_ENTITY_TYPE',
    UPDATE_MP1_VELOCITY_ENTITY_TYPE = '@form/UPDATE_MP1_VELOCITY_ENTITY_TYPE',
    UPDATE_MP2_DEPTH_ENTITY_TYPE = '@form/UPDATE_MP2_DEPTH_ENTITY_TYPE',
    UPDATE_MP2_VELOCITY_ENTITY_TYPE = '@form/UPDATE_MP2_VELOCITY_ENTITY_TYPE'
}

export const flexSensorChange = createAction(
    FlexActionType.FLEX_CHANGE_SENSOR,
    props<{ sensor: AvailableDynamicSection; index: 0 | 1 }>(),
);
export const flexChannelChange = createAction(FlexActionType.FLEX_CHANGE_CHANNEL, props<{ index: 0 | 1 }>());
export const flexMonitorPointChange = createAction(FlexActionType.FLEX_CHANGE_MONITOR_POINT, props<{ index: 0 | 1 }>());
export const setFlexSiltValue = createAction(FlexActionType.FLEX_SET_SILT_VALUE, props<{ mp: number; value: number }>());
export const flexSetCreateMode = createAction(FlexActionType.FLEX_SET_CREATE_MODE, props<{ mode: FlexCreateMode, message?: string }>());
export const evaluateFlexScanModeLock = createAction(FlexActionType.FLEX_EVALUATE_SCAN_MODE_LOCK);

export const loadSensorCollection = createAction(
    FlexActionType.LOAD_SENSOR_COLLECTION,
    props<{ deviceId: string; customerId: number }>()
);
export const loadSensorCollectionSuccess = createAction(
    FlexActionType.LOAD_SENSOR_COLLECTION_SUCCESS,
    props<{ collection: SensorConfigurationCollection }>()
);
export const loadSensorCollectionFailure = createAction(
    FlexActionType.LOAD_SENSOR_COLLECTION_FAILURE,
    props<{ error: HttpErrorResponse }>()
);

export const saveSensorCollection = createAction(
    FlexActionType.SAVE_SENSOR_COLLECTION,
    props<{ deviceId: string; customerId: number; collection: SensorConfigurationCollection }>()
);
export const saveSensorCollectionSuccess = createAction(
    FlexActionType.SAVE_SENSOR_COLLECTION_SUCCESS
);
export const saveSensorCollectionFailure = createAction(
    FlexActionType.SAVE_SENSOR_COLLECTION_FAILURE,
    props<{ error: HttpErrorResponse }>()
);

export const updateMp1Preferences = createAction(
    FlexActionType.UPDATE_MP1_PREFERENCES,
    props<{ preferences: SensorMonitoringPointDataSource }>()
);
export const updateMp2Preferences = createAction(
    FlexActionType.UPDATE_MP2_PREFERENCES,
    props<{ preferences: SensorMonitoringPointDataSource }>()
);
export const clearMp2Preferences = createAction(
    FlexActionType.CLEAR_MP2_PREFERENCES
);

export const updateMp1DepthEntityType = createAction(
    FlexActionType.UPDATE_MP1_DEPTH_ENTITY_TYPE,
    props<{ entityType: RegisterEntityType }>()
);
export const updateMp1VelocityEntityType = createAction(
    FlexActionType.UPDATE_MP1_VELOCITY_ENTITY_TYPE,
    props<{ entityType: RegisterEntityType }>()
);
export const updateMp2DepthEntityType = createAction(
    FlexActionType.UPDATE_MP2_DEPTH_ENTITY_TYPE,
    props<{ entityType: RegisterEntityType }>()
);
export const updateMp2VelocityEntityType = createAction(
    FlexActionType.UPDATE_MP2_VELOCITY_ENTITY_TYPE,
    props<{ entityType: RegisterEntityType }>()
);